var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 12c0 .7956-.3161 1.5587-.8787 2.1213s-1.3257.8787-2.1213.8787-1.5587-.3161-2.12132-.8787c-.56261-.5626-.87868-1.3257-.87868-2.1213s.31607-1.5587.87868-2.12132c.56262-.56261 1.32572-.87868 2.12132-.87868s1.5587.31607 2.1213.87868c.5626.56262.8787 1.32572.8787 2.12132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.45801 12c1.274-4.057 5.065-7 9.54199-7 4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.47699 0-8.26799-2.943-9.54199-7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.bddfb94ea68a2f9c5e95ec003891b4ec.svg";
export { ForwardRef as ReactComponent };